export default __webpack_public_path__ + "static/media/bank-linepay-mono.1dad06f8.svg";